import React from 'react';
import additional from './additional_grey.svg'

const Additional_grey = ({ isMobile }) => {
  return (
    <img width={isMobile ? "36" : "56"} height={isMobile ? "36" : "56"} src={additional} />
  )
};

export default Additional_grey;
